import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import withIntl from "../../../utils/withIntl";
import ExpandableRowSalesArea from "./ExpandableRowSalesArea";
import withStyles from "@material-ui/core/styles/withStyles";
import { SalesAreaDetails } from "../../../screens/Reporting";
import Divider from "@material-ui/core/Divider";
import SelectExportOptions from "./SelectExportOptions";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  container: {
    maxHeight: 800,
  },
});

const StyledCellHeader = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: "600",
    padding: "15px 3px 15px 3px",
    textAlign: "right",
  },
}))(TableCell);

function ReportingTable(props) {
  const classes = useStyles();
  let totalAllSalesAreas = new SalesAreaDetails(
    props.intl.formatMessage({ id: "total" }),
    null,
    null,
    0,
    0,
    {},
    { total: { amountIncVat: 0, amountExVat: 0, amountVat: 0 }, vats: {}, tipAmount: 0 }
  );
  props.salesAreas.forEach((salesArea) => {
    totalAllSalesAreas.numberOfBills += salesArea.numberOfBills;
    totalAllSalesAreas.amount += salesArea.amount;
    totalAllSalesAreas.revenue.tipAmount += salesArea.revenue.tipAmount;

    const addVatAmounts = (amountsObject, newAmountsObject) => {
      Object.keys(amountsObject.vats).forEach((vat) => {
        if (newAmountsObject.vats[vat] == null) {
          newAmountsObject.vats[vat] = { amountIncVat: 0, amountExVat: 0, amountVat: 0 };
        }
        newAmountsObject.vats[vat].amountIncVat += amountsObject.vats[vat].amountIncVat;
        newAmountsObject.vats[vat].amountVat += amountsObject.vats[vat].amountVat;
        newAmountsObject.vats[vat].amountExVat += amountsObject.vats[vat].amountExVat;
      });

      newAmountsObject.total.amountIncVat += amountsObject.total.amountIncVat;
      newAmountsObject.total.amountVat += amountsObject.total.amountVat;
      newAmountsObject.total.amountExVat += amountsObject.total.amountExVat;
    };

    addVatAmounts(salesArea.revenue, totalAllSalesAreas.revenue);

    Object.keys(salesArea.amountPerPaymentType).forEach((paymentTypeKey) => {
      if (totalAllSalesAreas.amountPerPaymentType[paymentTypeKey] == null)
        totalAllSalesAreas.amountPerPaymentType[paymentTypeKey] = {
          count: 0,
          total: { amountIncVat: 0, amountExVat: 0, amountVat: 0 },
          vats: {},
        };

      totalAllSalesAreas.amountPerPaymentType[paymentTypeKey].count +=
        salesArea.amountPerPaymentType[paymentTypeKey].count;

      addVatAmounts(
        salesArea.amountPerPaymentType[paymentTypeKey],
        totalAllSalesAreas.amountPerPaymentType[paymentTypeKey]
      );
    });
  });

  return (
    <TableContainer className={classes.container} component={Paper}>
      <Table className={classes.table} size="small">
        <TableHead>
          <TableRow>
            <StyledCellHeader />
            <StyledCellHeader style={{ textAlign: "left" }}>
              {props.intl.formatMessage({ id: "sales_areas" })}
            </StyledCellHeader>
            <StyledCellHeader>{props.intl.formatMessage({ id: "number_of_bills" })}</StyledCellHeader>
            <StyledCellHeader />
            <StyledCellHeader>{props.intl.formatMessage({ id: "amount" })}</StyledCellHeader>
            <StyledCellHeader />
            <StyledCellHeader>
              <SelectExportOptions
                key={props.salesAreas.length}
                salesAreas={props.salesAreas.concat(totalAllSalesAreas)}
              />
            </StyledCellHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          <Divider fullWidth light style={{ marginTop: 10 }} />
          {props.salesAreas.map((salesArea, index) => {
            return <ExpandableRowSalesArea key={salesArea.renderedName + index} salesArea={salesArea} />;
          })}
          <Divider fullWidth light style={{ marginTop: 10 }} />
          {totalAllSalesAreas && <ExpandableRowSalesArea total={true} salesArea={totalAllSalesAreas} />}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default withIntl(ReportingTable);
